export const CheckIcon = ({ className }) => (
  <svg
    className={className}
    width="11"
    height="15"
    viewBox="0 0 11 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1.5 7.5L4.5 11.5L9.5 2.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftArrowIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.293 5.293a1 1 0 1 1 1.414 1.414L10.414 12l5.293 5.293a1 1 0 1 1-1.414 1.414L9 13.414a2 2 0 0 1 0-2.828z"
    />
  </svg>
);

export const RightArrowIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.293 5.293a1 1 0 0 1 1.414 0L15 10.586a2 2 0 0 1 0 2.828l-5.293 5.293a1 1 0 1 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414"
    />
  </svg>
);

export const FiltersIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 16a1 1 0 1 1 0 2h-2a1 1 0 0 1 0-2zm4-5a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2zm3-5a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z"
    />
  </svg>
);

export const DownloadIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.293 11.293a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414 0l5-5a1 1 0 1 0-1.414-1.414L13 14.586V4a1 1 0 1 0-2 0v10.586l-3.293-3.293a1 1 0 0 0-1.414 0M17 19H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2"
    />
  </svg>
);

export const SearchIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 9.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m2 0a6.47 6.47 0 0 1-1.252 3.833l4.959 4.96a1 1 0 1 1-1.414 1.414l-4.96-4.959A6.5 6.5 0 1 1 16 9.5"
    />
  </svg>
);

export const CrossIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.293 5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 1 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 1 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 1 1 1.414-1.414L12 10.586z"
    />
  </svg>
);

export const DeleteIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 8a1 1 0 0 0-1-1H8.5a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 0 1.2l3 4a1 1 0 0 0 .8.4H18a1 1 0 0 0 1-1zm-3.207.293a1 1 0 1 1 1.414 1.414L14.914 12l2.293 2.293a1 1 0 1 1-1.414 1.414L13.5 13.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L12.086 12 9.793 9.707a1 1 0 1 1 1.414-1.414l2.293 2.293zM21 16a3 3 0 0 1-3 3H8.5a3 3 0 0 1-2.4-1.2l-3-4a3 3 0 0 1 0-3.6l3-4A3 3 0 0 1 8.5 5H18a3 3 0 0 1 3 3z"
    />
  </svg>
);

export const BiometricIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2 19v-2a1 1 0 1 1 2 0v2a1 1 0 0 0 1 1h2a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3m18 0v-2a1 1 0 1 1 2 0v2a3 3 0 0 1-3 3h-2a1 1 0 1 1 0-2h2a1 1 0 0 0 1-1m-5.555-3.332a1 1 0 1 1 1.11 1.664c-.974.649-2.318.918-3.555.918s-2.581-.27-3.555-.918a1 1 0 1 1 1.11-1.664c.526.351 1.432.582 2.445.582s1.919-.23 2.445-.582M11 9a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2zm-4 .5V8a1 1 0 0 1 2 0v1.5a1 1 0 1 1-2 0m8 0V8a1 1 0 1 1 2 0v1.5a1 1 0 1 1-2 0M2 7V5a3 3 0 0 1 3-3h2a1 1 0 0 1 0 2H5a1 1 0 0 0-1 1v2a1 1 0 0 1-2 0m18 0V5a1 1 0 0 0-1-1h-2a1 1 0 1 1 0-2h2a3 3 0 0 1 3 3v2a1 1 0 1 1-2 0"
    />
  </svg>
);

export const PasscodeSuccessCheck = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="44"
    viewBox="0 0 32 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6.5 22.5L13.5 29.5L25.5 12.5"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 6.106a11 11 0 0 1-7-1.884 11 11 0 0 1-7 1.884v5.95a7 7 0 0 0 3.87 6.26L12 19.882l3.13-1.566a7 7 0 0 0 3.87-6.26zm2 5.95a9 9 0 0 1-4.975 8.05l-3.578 1.788a1 1 0 0 1-.894 0l-3.578-1.789A9 9 0 0 1 3 12.055V5a1 1 0 0 1 1.11-.994l.698.078a9 9 0 0 0 6.224-1.622l.387-.276.136-.082a1 1 0 0 1 1.026.082l.387.276a9 9 0 0 0 6.224 1.622l.698-.078A1 1 0 0 1 21 5z"
    />
  </svg>
);

export const NotificationBellIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="9" cy="3" r="3" fill="currentColor" />
    <rect x="2" y="4" width="14" height="11" rx="5" fill="currentColor" />
    <rect x="0" y="14" width="18" height="3" rx="1" fill="currentColor" />
    <circle cx="9" cy="19" r="3" fill="currentColor" />
  </svg>
);

export const NotificationIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 20a1 1 0 0 1 0 2h-2a1 1 0 1 1 0-2zm3-9.5a4 4 0 0 0-8 0v2.24a3 3 0 0 1-.758 1.992l-1.275 1.436A.5.5 0 0 0 6.34 17h11.32a.5.5 0 0 0 .373-.832l-1.275-1.436A3 3 0 0 1 16 12.74zm2 2.24c0 .244.09.481.253.664l1.275 1.435c1.433 1.612.29 4.16-1.868 4.161H6.34c-2.157 0-3.301-2.549-1.868-4.161l1.275-1.435c.163-.183.253-.42.253-.665V10.5a6 6 0 0 1 5-5.916V3a1 1 0 1 1 2 0v1.584a6 6 0 0 1 5 5.916z"
    />
  </svg>
);

export const NewLoginNotificationIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 11a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zm-7 5.5v-3a1 1 0 1 1 2 0v3a1 1 0 1 1-2 0m9 2.5a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h8V6a3 3 0 0 0-5.91-.732 1 1 0 0 1-1.94-.486A5 5 0 0 1 17 6v2a3 3 0 0 1 3 3z"
    />
  </svg>
);

export const TabHomeIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="m18 8.42-5.427-3.798a1 1 0 0 0-1.146 0L6 8.42V18a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zM20 18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V9.82l-1.427 1a1 1 0 0 1-1.146-1.64l8.852-6.197a3 3 0 0 1 3.441 0l8.853 6.198a1 1 0 0 1-1.146 1.638L20 9.82z"
    />
  </svg>
);

export const TabCardIcon = ({ className }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="2" y="5" width="18" height="12" rx="3" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2 9H20" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const TabHistoryIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M2 12C2 6.477 6.477 2 12 2a1 1 0 1 1 0 2 8 8 0 1 0 7.169 11.555 1 1 0 0 1 1.791.89A10 10 0 0 1 12 22C6.477 22 2 17.523 2 12m9-5a1 1 0 1 1 2 0v4.382l3.447 1.723a1 1 0 0 1-.894 1.79l-4-2A1 1 0 0 1 11 12zm10.01 4a1 1 0 0 1 0 2H21a1 1 0 1 1 0-2zM19.79 6.5a1 1 0 1 1 0 2h-.01a1 1 0 0 1 0-2zM16.51 3.219a1 1 0 1 1 0 2h-.01a1 1 0 1 1 0-2z"
    />
  </svg>
);

export const TabReferralIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M16 17v-2h-2a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 2 0v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0m4-8c0-1.025-.39-2.047-1.172-2.829-.672-.671-1.365-1.063-2.039-1.21-.663-.146-1.375-.073-2.132.296-.635.31-1.412.92-1.763 1.62a1 1 0 0 1-1.787 0c-.352-.7-1.129-1.31-1.764-1.62-.757-.37-1.469-.442-2.132-.297-.674.148-1.367.54-2.04 1.211a4 4 0 0 0 0 5.657l7.536 7.536a1 1 0 0 1-1.414 1.414l-7.535-7.535a6 6 0 0 1 0-8.486c.88-.88 1.9-1.504 3.023-1.75 1.135-.25 2.305-.1 3.439.453.539.263 1.205.7 1.78 1.29a6.6 6.6 0 0 1 1.78-1.29c1.134-.553 2.304-.703 3.439-.454 1.123.247 2.143.87 3.023 1.751A5.99 5.99 0 0 1 22 9a1 1 0 0 1-2 0"
    />
  </svg>
);

export const TabProfileIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M12 13c2.135 0 3.885.346 5.214 1.148 1.37.825 2.19 2.073 2.556 3.64C20.206 19.662 18.558 21 17 21H7c-1.558 0-3.206-1.337-2.77-3.213.365-1.566 1.187-2.814 2.556-3.64C8.116 13.348 9.866 13 12 13m0 2c-1.955 0-3.291.323-4.182.86-.85.513-1.381 1.272-1.64 2.381a.5.5 0 0 0 .143.483c.15.157.396.276.679.276h10c.283 0 .53-.119.679-.276a.5.5 0 0 0 .142-.483c-.258-1.109-.79-1.868-1.64-2.38C15.292 15.322 13.956 15 12 15m2-7.5c0-1.148-.235-1.728-.497-2.023C13.265 5.209 12.844 5 12 5s-1.265.209-1.503.477C10.235 5.772 10 6.352 10 7.5s.235 1.728.497 2.023c.238.268.659.477 1.503.477.845 0 1.265-.209 1.503-.477.262-.295.497-.875.497-2.023m2 0c0 1.352-.265 2.522-1.003 3.352C14.235 11.709 13.156 12 12 12s-2.235-.291-2.997-1.148C8.265 10.022 8 8.852 8 7.5s.265-2.522 1.003-3.352C9.765 3.291 10.845 3 12 3c1.156 0 2.235.291 2.997 1.148.738.83 1.003 2 1.003 3.352"
    />
  </svg>
);

export const TabPlusIcon = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M11 18v-5H6a1 1 0 1 1 0-2h5V6a1 1 0 1 1 2 0v5h5a1 1 0 1 1 0 2h-5v5a1 1 0 1 1-2 0"
    />
  </svg>
);

export const FreezeCardIcon = ({ className }) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect width="40" height="40" rx="12" fill="#E8F1FF" />
    <rect x="18.5" y="10" width="3" height="20" rx="1.5" fill="#3B82F6" />
    <rect x="10" y="18.5" width="20" height="3" rx="1.5" fill="#3B82F6" />
    <circle cx="13" cy="13" r="2" fill="#3B82F6" />
    <circle cx="27" cy="13" r="2" fill="#3B82F6" />
    <circle cx="13" cy="27" r="2" fill="#3B82F6" />
    <circle cx="27" cy="27" r="2" fill="#3B82F6" />
  </svg>
);

export const FreezeIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 21v-3.586l-2.293 2.293a1 1 0 1 1-1.414-1.414L11 14.586V13H9.414l-3.707 3.707a1 1 0 1 1-1.414-1.414L6.586 13H3a1 1 0 1 1 0-2h3.586L4.293 8.707a1 1 0 1 1 1.414-1.414L9.414 11H11V9.414L7.293 5.707a1 1 0 1 1 1.414-1.414L11 6.586V3a1 1 0 1 1 2 0v3.586l2.293-2.293a1 1 0 1 1 1.414 1.414L13 9.414V11h1.586l3.707-3.707a1 1 0 1 1 1.414 1.414L17.414 11H21a1 1 0 1 1 0 2h-3.586l2.293 2.293a1 1 0 1 1-1.414 1.414L14.586 13H13v1.586l3.707 3.707a1 1 0 1 1-1.414 1.414L13 17.414V21a1 1 0 1 1-2 0"
    />
  </svg>
);

export const UnfreezeIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.293 2.263c.39-.39 1.024-.39 1.415 0l.116.117c.229.228.333.554.28.874A7.5 7.5 0 0 0 13 4.5c0 1.358.351 2.54.868 3.352C14.393 8.676 14.995 9 15.5 9c.445 0 .955-.246 1.434-.868l.074-.085a1 1 0 0 1 1.488.057A8.437 8.437 0 0 1 6.036 19.45a8.436 8.436 0 0 1 0-11.93zm-.585 14.444a1.829 1.829 0 1 0 2.585 0L12 15.414zM7.45 8.935a6.435 6.435 0 0 0 .787 9.77 3.83 3.83 0 0 1 1.056-3.412l2-2c.39-.39 1.024-.39 1.415 0l2 2a3.82 3.82 0 0 1 1.054 3.412q.415-.298.788-.67a6.44 6.44 0 0 0 1.032-7.752c-.596.44-1.298.717-2.081.717-1.427 0-2.577-.908-3.32-2.075-.622-.978-1.024-2.223-1.143-3.579z"
    />
  </svg>
);

export const TopUpIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 6a1 1 0 0 0-1-1H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h13a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H7a1 1 0 0 1 0-2h11zm-1 7a1 1 0 1 1 0 2h-1a1 1 0 1 1 0-2zm3-5.826c1.165.412 2 1.52 2 2.826v8a3 3 0 0 1-3 3H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h11a3 3 0 0 1 3 3z"
    />
  </svg>
);

export const CardCreateIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.37 9.775a1 1 0 0 0 1.337-.068l5-5a1 1 0 1 0-1.414-1.414L18 7.586l-1.293-1.293a1 1 0 1 0-1.414 1.414l2 2zM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2h16zm2-5a1 1 0 1 0-2 0v1H4V7a1 1 0 0 1 1-1h7a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3z"
    />
  </svg>
);

export const ShootingStarIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15 8a1 1 0 0 1 .895.553l1.85 3.7 3.702 1.852a1 1 0 0 1 0 1.79l-3.702 1.85-1.85 3.702a1 1 0 0 1-1.79 0l-1.851-3.702-3.701-1.85a1 1 0 0 1 0-1.79l3.7-1.851 1.852-3.701A1 1 0 0 1 15 8m-1.105 5.447c-.097.194-.254.35-.448.448L11.237 15l2.21 1.105.138.084a1 1 0 0 1 .31.364L15 18.763l1.105-2.21a1 1 0 0 1 .448-.448L18.763 15l-2.21-1.105a1 1 0 0 1-.448-.448L15 11.237zM3.293 9.293a1 1 0 0 1 1.414 0l2.5 2.5a1 1 0 1 1-1.414 1.414l-2.5-2.5a1 1 0 0 1 0-1.414m1-5a1 1 0 0 1 1.414 0l5.5 5.5a1 1 0 1 1-1.414 1.414l-5.5-5.5a1 1 0 0 1 0-1.414m5-1a1 1 0 0 1 1.414 0l2.5 2.5a1 1 0 1 1-1.414 1.414l-2.5-2.5a1 1 0 0 1 0-1.414"
    />
  </svg>
);

export const RevealIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.293 3.293a1 1 0 0 1 1.414 0l13.225 13.225.017.017 2.758 2.758a1 1 0 1 1-1.414 1.414l-2.212-2.212C15.491 19.407 13.733 20 12 20c-2.217 0-4.483-.97-6.387-2.35-1.91-1.385-3.557-3.256-4.511-5.211a1 1 0 0 1 0-.879C1.99 9.743 3.48 7.996 5.228 6.642L3.293 4.707a1 1 0 0 1 0-1.414m3.36 4.774C5.183 9.161 3.926 10.567 3.13 12c.82 1.473 2.127 2.922 3.66 4.032C8.478 17.257 10.338 18 12 18c1.145 0 2.387-.354 3.606-.98l-1.575-1.575a4 4 0 0 1-5.477-5.478zM12 4c2.217 0 4.483.97 6.387 2.35 1.91 1.385 3.556 3.256 4.511 5.212a1 1 0 0 1 0 .877c-.606 1.241-1.488 2.442-2.529 3.502a1 1 0 0 1-1.428-1.4A12 12 0 0 0 20.871 12c-.82-1.472-2.128-2.92-3.66-4.031C15.522 6.743 13.662 6 12 6c-.624 0-1.28.105-1.952.306a1.001 1.001 0 0 1-.572-1.917A8.9 8.9 0 0 1 12 4m-2 8a2 2 0 0 0 2 2c.179 0 .35-.027.516-.07l-2.447-2.447q-.068.248-.069.517"
    />
  </svg>
);

export const CopyIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 11a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1zm-6-6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3v-3a3 3 0 0 1 3-3h3zm2 3h3a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3z"
    />
  </svg>
);

export const EditIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.043 4.043a2.768 2.768 0 1 1 3.914 3.914l-12.75 12.75A1 1 0 0 1 6.5 21H4a1 1 0 0 1-1-1v-2.5a1 1 0 0 1 .293-.707zM5 17.914V19h1.086l10-10L15 7.914zM18.543 5.457c-.3-.3-.786-.3-1.086 0L16.414 6.5 17.5 7.586l1.043-1.043c.3-.3.3-.786 0-1.086"
    />
  </svg>
);

export const PhoneIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 20a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zm-4-3h.012a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2m-4 5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3z"
    />
  </svg>
);

export const MailIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.8 3.4-7.2 5.4a1 1 0 0 1-1.2 0L4.2 7.4q-.2.25-.2.6v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8q0-.35-.2-.6M18.334 6H5.666L12 10.75z"
    />
  </svg>
);

export const CalendarIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1m13 9H4v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zM5 6a1 1 0 0 0-1 1v2h16V7a1 1 0 0 0-1-1z"
    />
  </svg>
);

export const LangIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.125 21.213a10.1 10.1 0 0 1-3.187-2.15 10.1 10.1 0 0 1-2.15-3.188A9.7 9.7 0 0 1 2 11.988q0-2.063.788-3.875a10.2 10.2 0 0 1 2.15-3.175 10.1 10.1 0 0 1 3.187-2.15A9.7 9.7 0 0 1 12.012 2q2.063 0 3.875.788a10.2 10.2 0 0 1 3.175 2.15 10.2 10.2 0 0 1 2.15 3.175Q22 9.925 22 11.988t-.788 3.887a10.1 10.1 0 0 1-2.15 3.188 10.2 10.2 0 0 1-3.175 2.15 9.6 9.6 0 0 1-3.875.787 9.7 9.7 0 0 1-3.887-.788M12 19.95q.65-.9 1.125-1.875T13.9 16h-3.8q.3 1.1.775 2.075T12 19.95m-2.6-.4q-.45-.824-.787-1.713A15 15 0 0 1 8.05 16H5.1a8.3 8.3 0 0 0 1.813 2.175A7.2 7.2 0 0 0 9.4 19.55m5.2 0a7.2 7.2 0 0 0 2.487-1.375A8.3 8.3 0 0 0 18.9 16h-2.95q-.225.95-.562 1.837a14 14 0 0 1-.788 1.713M4.25 14h3.4a13.208 13.208 0 0 1-.15-2 13 13 0 0 1 .15-2h-3.4A7.959 7.959 0 0 0 4 12a8 8 0 0 0 .25 2m5.4 0h4.7q.075-.5.113-.988.037-.487.037-1.012a13 13 0 0 0-.15-2h-4.7q-.075.5-.113.988Q9.5 11.475 9.5 12a13 13 0 0 0 .15 2m6.7 0h3.4a7.953 7.953 0 0 0 .25-2 8 8 0 0 0-.25-2h-3.4q.075.5.112.988.038.487.038 1.012a13 13 0 0 1-.15 2m-.4-6h2.95a8.3 8.3 0 0 0-1.812-2.175A7.2 7.2 0 0 0 14.6 4.45q.45.825.787 1.712.338.888.563 1.838M10.1 8h3.8q-.3-1.1-.775-2.075A12.7 12.7 0 0 0 12 4.05q-.65.9-1.125 1.875T10.1 8m-5 0h2.95q.224-.95.563-1.838.337-.887.787-1.712Q8 4.9 6.912 5.825A8.3 8.3 0 0 0 5.1 8"
    />
  </svg>
);

export const HelpIcon = ({ className, ...props }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 12a8 8 0 1 0-16 0 8 8 0 0 0 16 0m-7.99 4a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2zM14 10c0-.537-.18-1.041-.497-1.398C13.202 8.263 12.729 8 12 8c-1.079 0-1.665.584-1.894 1.303A1 1 0 0 1 8.2 8.697C8.672 7.213 9.983 6 12 6c1.271 0 2.298.487 2.997 1.273C15.68 8.041 16 9.037 16 10c0 .73-.177 1.332-.501 1.839-.31.485-.72.823-1.062 1.082-.738.557-1.217.83-1.53 1.502a1 1 0 0 1-1.813-.846c.577-1.235 1.598-1.844 2.137-2.252.296-.223.47-.388.584-.564.098-.155.185-.374.185-.761m8 2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
    />
  </svg>
);

export const SharePhoneIllustration = ({ className }) => (
  <svg
    className={className}
    width="64"
    height="90"
    viewBox="0 0 64 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="32" cy="58" r="32" fill="var(--obank-share-phone-icon-bg)" />
    <rect
      x="17"
      y="40"
      width="30"
      height="40"
      rx="8"
      fill="var(--obank-share-phone-icon-body)"
    />
    <rect
      x="21"
      y="46"
      width="22"
      height="24"
      rx="2"
      fill="var(--obank-share-phone-icon-detail)"
    />
    <circle cx="32" cy="76" r="4" fill="var(--obank-share-phone-icon-detail)" />
  </svg>
);
